import * as React from 'react';
import { Form } from 'formik';

import { IEditForm } from '../types';
import { tagGroupChoices } from '../TagGroups';
import { FormInput, Button, FormSelect } from 'src/components';

const EditForm = ({
  id,
  errors,
  isSubmitting,
  children,
  isValid,
  dirty,
}: IEditForm) => (
  <div className="pt-5 px-6 mx-px">
    <Form autoComplete="off">
      {children}
      <div className="flex mb-4">
        <div className="flex-1 flex mb-4">
          <label className="pt-2 pr-6" htmlFor={`name-${id}`}>
            Name*
          </label>
          <div className="flex-1">
            <FormInput className="flex-1 w-full" name={`name-${id}`} />
          </div>
        </div>
        <div className="flex-1 flex ml-6 mb-4">
          <label className="pt-2 pr-6" htmlFor={`regexMatch-${id}`}>
            RegEx
          </label>
          <div className="flex-1">
            <FormInput className="flex-1 w-full" name={`regexMatch-${id}`} />
          </div>
        </div>
      </div>

      <div className="flex mb-4">
        <div className="flex-1 mb-4">
          <span className="pt-2 pr-6">Duplicate on item level</span>
          <div className="mt-3">
            <FormSelect
              className="w-full"
              name={`allowDuplicateOnItemLevel-${id}`}
              options={tagGroupChoices}
            />
          </div>
        </div>
        <div className="flex-1 mb-4 ml-6">
          <span className="pt-2 pr-6">Duplicate on parameter level</span>
          <div className="mt-3">
            <FormSelect
              className="w-full"
              name={`allowDuplicateOnParameterLevel-${id}`}
              options={tagGroupChoices}
            />
          </div>
        </div>
        <div className="flex-1 mb-4 ml-6">
          <span className="pt-2 pr-6">Duplicate in system</span>
          <div className="mt-3">
            <FormSelect
              className="w-full"
              name={`allowDuplicateInSystem-${id}`}
              options={tagGroupChoices}
            />
          </div>
        </div>
      </div>

      <div className="flex items-center pt-4 pb-5 bg-grey-transparent sticky pin-b pin-r">
        <div className="flex-1 text-yellow">
          {Object.values(errors).join(', ')}
        </div>
        <Button
          type="submit"
          background="grey"
          loading={isSubmitting}
          loadingLabel="Saving"
          disabled={!dirty || !isValid}
        >
          Save
        </Button>
      </div>
    </Form>
  </div>
);

export default EditForm;



// WEBPACK FOOTER //
// ./src/views/Admin/TagGroups/components/EditForm.tsx